import styled, { css, DefaultTheme } from 'styled-components';
import { Field as UnstyledField } from 'formik';

type ContentProps = {
  required?: boolean;
};

type CheckmarkProps = {
  error: boolean;
};

export const Label = styled.label`
  display: flex;
  min-height: 32px;
`;

export const Container = styled.div`
  ${({ theme }) => css`
    position: relative;
    display: flex;
    align-items: center;
    padding-left: 40px;
    width: 100%;
    user-select: none;

    &:hover input ~ span {
      background-color: ${theme.colors.neutralGray5};
    }

    & input:checked ~ span {
      background-color: ${theme.colors.primary70};
    }

    & input:checked ~ span::after {
      content: '';
    }
  `}
`;

const fieldModifiers = {
  required: (theme: DefaultTheme) => css`
    &::after {
      content: '*';
      vertical-align: middle;
      color: ${theme.colors.statusDanger50};
    }
  `,
};

export const Field = styled(UnstyledField)`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
`;

export const Checkmark = styled.span<CheckmarkProps>`
  ${({ theme, error }) => css`
    position: absolute;
    top: 4px;
    left: 0;
    height: 24px;
    width: 24px;
    background-color: ${theme.colors.globalWhite100};
    border: 1px solid
      ${error ? theme.colors.statusDanger40 : 'rgba(102, 102, 102, 0.24)'};
    border-radius: 4px;
    cursor: pointer;

    &::after {
      content: none;
      position: absolute;
      top: 5px;
      left: 50%;

      border: solid white;
      border-width: 0 1px 1px 0;

      width: 6px;
      height: 12px;
      transform: rotate(45deg) translateX(-50%);
    }
  `}
`;

export const Content = styled.p<ContentProps>`
  ${({ theme, required }) => css`
    font-size: 1.6rem;
    line-height: 2.4rem;
    font-weight: 400;
    color: ${theme.colors.neutralDark80};
    margin-top: 4px;

    strong {
      font-weight: 700;
    }

    ${required && fieldModifiers.required(theme)}
  `}
`;

export const FeedbackMessage = styled.span`
  ${({ theme }) => css`
    font-weight: 400;
    font-size: 14px;

    display: block;
    margin-top: 0.4rem;

    color: ${theme.colors.statusDanger40};
  `};
`;
